export class Requisition {
    constructor() {
        this.cloudFileLocation = '';
        this.hrxmlCloudFileLocation = '';
        this.length = '';
        this.fileSize = '';
        this.fileName = '';
        this.hrxmlFileName = '';
        this.user = null;
        this.company = null;
        this.clientOrBU = null;
        this.isSharedClientRequisition = false;
        this.sharedClientBuOrCorpId = null;
    }
}
//# sourceMappingURL=requisition.js.map